import { type ReactNode } from 'react';

type Props = {
  dirty: boolean;
  saving: boolean;
  saved: boolean;
  error: string;
  onSubmit: () => void;
  onReset: () => void;
};

const SAVE_CLS =
  'rounded-lg bg-brand-red px-base py-sm text-sm font-medium text-white transition-colors hover:bg-brand-coral disabled:opacity-50 disabled:hover:bg-brand-red';
const CANCEL_CLS =
  'rounded-lg border border-border-subtle px-base py-sm text-sm text-text-secondary transition-colors hover:bg-surface-elevated hover:text-text-primary disabled:opacity-50';

function StatusLine({
  error,
  saved,
  dirty,
}: {
  error: string;
  saved: boolean;
  dirty: boolean;
}): ReactNode {
  if (error) return <p className="text-sm text-error">{error}</p>;
  if (saved && !dirty)
    return <p className="text-sm text-success">Cambios guardados.</p>;
  return null;
}

type BtnProps = {
  disabled: boolean;
  saving: boolean;
  onSubmit: () => void;
  onReset: () => void;
};

function Buttons({ disabled, saving, onSubmit, onReset }: BtnProps): ReactNode {
  return (
    <div className="flex justify-end gap-sm">
      <button
        type="button"
        onClick={onReset}
        disabled={disabled}
        className={CANCEL_CLS}
      >
        Cancelar
      </button>
      <button
        type="button"
        onClick={onSubmit}
        disabled={disabled}
        className={SAVE_CLS}
      >
        {saving ? 'Guardando...' : 'Guardar'}
      </button>
    </div>
  );
}

const WRAPPER_CLS =
  'sticky bottom-0 -mx-base border-t border-border-subtle bg-bg-primary/95 px-base py-base backdrop-blur sm:static sm:mx-0 sm:border-0 sm:bg-transparent sm:p-0';

export function ActionBar(p: Props): ReactNode {
  const disabled = !p.dirty || p.saving;
  return (
    <div className={WRAPPER_CLS}>
      <div className="space-y-sm">
        <StatusLine error={p.error} saved={p.saved} dirty={p.dirty} />
        <Buttons
          disabled={disabled}
          saving={p.saving}
          onSubmit={p.onSubmit}
          onReset={p.onReset}
        />
      </div>
    </div>
  );
}
